import Vue from "vue";
import App from "./App.vue";
import router from "./router";
Vue.config.productionTip = false;
import axios from "axios";
Vue.use(VueAxios, axios);
import VueAxios from "vue-axios";
import VueMeta from "vue-meta";
Vue.use(VueMeta);
import Notifications from "vue-notification";
Vue.use(Notifications);
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import VueCurrencyFilter from "vue-currency-filter";
Vue.use(VueCurrencyFilter, {
   symbol: "$",
   thousandsSeparator: ".",
   fractionCount: 0,
   fractionSeparator: ",",
   symbolPosition: "front",
   symbolSpacing: true,
});
import money from "v-money";
Vue.use(money, { precision: 0 });
import vmodal from "vue-js-modal";
Vue.use(vmodal);

import VueSweetalert2 from "vue-sweetalert2";

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

import VCalendar from "v-calendar";
Vue.use(VCalendar, {
   componentPrefix: "vc",
});

// Environment variables
Vue.prototype.$api_key = process.env.VUE_APP_API_KEY;
Vue.prototype.$editor_api_key = process.env.VUE_APP_EDITOR_API_KEY;
Vue.prototype.$base_url = process.env.VUE_APP_BASE_URL;
Vue.prototype.$base_url_shop = process.env.VUE_APP_BASE_URL_SHOP;

new Vue({
   router,
   render: (h) => h(App),
}).$mount("#app");
